import { HighlighFields } from '@src/main/ui/components/common/Dashboard/common/fields/highlighter/HighlighFields';
import { useSearchContext } from '@src/main/ui/providers/search/SearchContextProvider';
import { FC } from 'react';
import Highlighter from 'react-highlight-words';

interface Props {
  description?: string;
  highlighFields?: HighlighFields[];
}

const defaultProps = {
  description: undefined,
  highlighFields: undefined,
};

const DescriptionCardText: FC<Props> = ({ description, highlighFields }) => {
  const { searchInput } = useSearchContext();
  const fieldToHighligh: HighlighFields = 'description';
  return (
    <>
      {highlighFields?.includes(fieldToHighligh) ? (
        <Highlighter searchWords={[searchInput]} textToHighlight={description || ''} />
      ) : (
        description
      )}
    </>
  );
};

DescriptionCardText.defaultProps = defaultProps;

export default DescriptionCardText;
